import "./formaBase.css";

//form wrapper calculator

const FormaBase = ({ children }) => {
  return <div className="formabase">{children}</div>;
};

export default FormaBase
